import React from "react";
import "./style.css";

export const CourseLandingViewMore = ({ text, expanded_text, language }) => {

  const [isExpanded, setExpanded] = React.useState(false);

  const random_uuid = 'random_uuid_' + Math.floor((Math.random() * 10000) + (Math.random() * 10000));

  const translations = {
    "more": {
      "en": "View more",
      "es": "Ver más",
      "pt": "Ver mais",
      "fr": "Voir plus"
    },
    "less": {
      "en": "View less",
      "es": "Ver menos",
      "pt": "Ver menos",
      "fr": "Voir moins"
    }
  };

  const view_more_icon = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-down" viewBox="0 0 16 16"><path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"></path></svg>';
  const view_less_icon = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-up" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"></path></svg>';

  const [view_more_text, setView_more_text] = React.useState(translations["more"][language] + ' ' + view_more_icon);

  const onClick = () => {

    setView_more_text(isExpanded ? (translations["more"][language] + ' ' + view_more_icon) : (translations["less"][language] + ' ' + view_less_icon));
    setExpanded(!isExpanded);

    if (isExpanded) {

      let element = document.getElementById(random_uuid);

      setTimeout(() => {
        element.scrollIntoView({ behavior: 'smooth' });
      }, 300);
      
    }

  }

  return (
    <div className="course_landing_view_more">
      <div className="course_landing_text list-disc" dangerouslySetInnerHTML={{ __html: text }}>
      </div>
      <div id={random_uuid} className={`course_landing_expanded_text list-disc ${isExpanded ? 'active' : ''}`} dangerouslySetInnerHTML={{ __html: expanded_text }}>
      </div>
      { expanded_text.length > 10 &&
        <div onClick={onClick} className="text-uppercase course_landing_view_more_view_more" dangerouslySetInnerHTML={{ __html: view_more_text }}></div>
      }
    </div>
  );
};
